module.exports = __webpack_public_path__ + "img/IMG_6689_L_Wood.3aeaa533.jpg";